import CarrouselStyle from "./style.module.scss";

type ArrowsProps = {
  contChildrens: number;
  tab: number;
  setTab: React.Dispatch<React.SetStateAction<number>>;
};

const BTNArrows: React.FC<ArrowsProps> = ({ contChildrens, tab, setTab }) => {
  return (
    <div
      title='container-arrows'
      className={`${CarrouselStyle.arrowContainer} `}>
      <button
        title='arrow-left'
        className={`${CarrouselStyle.btnMovimiento} bg-transparent border-0`}
        onClick={() => setTab(tab - 1 >= 0 ? tab - 1 : contChildrens - 1)}>
        <div
          className={`${CarrouselStyle.arrow} ${CarrouselStyle.arrow_left}`}></div>
      </button>

      <button
        title='arrow-right'
        className={`${CarrouselStyle.btnMovimiento} bg-transparent border-0`}
        onClick={() => setTab(tab + 1 > contChildrens - 1 ? 0 : tab + 1)}>
        <div
          className={`${CarrouselStyle.arrow} ${CarrouselStyle.arrow_right}`}></div>
      </button>
    </div>
  );
};

export default BTNArrows;
